function initProfileImageEdit () {
    $('.js-file-input-container').each(function clickHandler () {
        const $container = $(this)

        const $removeButton = $container.find('.js-remove-profile-image')
        const $preview = $container.find('.js-preview-image')
        const $fileInput = $container.find('input[type="file"]')
        const $keepInput = $container.find('input[type="hidden"][name$="_keep"]')

        if (!$fileInput.length || !$keepInput.length) return

        $keepInput.val('1')

        $removeButton.on('click', () => {
            $preview.addClass('u-hidden').removeClass('position-relative d-inline-block')
            $fileInput.removeClass('u-hidden u-hidden-file')
            $keepInput.val('1')
        })

        $fileInput.on('change', function changeFileInputHandler () {
            const hasFile = this.files && this.files.length > 0
            $keepInput.val(hasFile ? '0' : '1')
        })
    })
}

export const initForms = () => {
    initProfileImageEdit()
}
